import { getCurrentScreen } from '@/hooks/useHeaderDataConfig/getCurrentScreen'
import { ScreenNames } from '~types/index'

interface IGetHeaderDataByPathname {
  screenNames: ScreenNames
  pathname?: string
  useDomain: boolean
  seoConfig: { defaultTitle: string }
}

const getCurrentScreenName = ({
  screenNames,
  pathname,
  useDomain,
  seoConfig,
}: IGetHeaderDataByPathname) => {
  const parts: string[] = pathname?.split('/') || []
  const paths: string[] = useDomain ? parts.slice(1) : parts.slice(2)
  const defaultScreenName = {
    pageTitle: seoConfig?.defaultTitle,
  }

  const screenName = getCurrentScreen(paths, screenNames, true)

  if (Object.keys(screenName).length === 0) {
    return defaultScreenName
  }
  return screenName
}

export { getCurrentScreenName }
